import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { academyGet } from './academyApi';
import { userHasAnyRole } from '../../../helpers/roleHelpers';
import { TRAINING_HOME, TRAINING_TABS, workspaceHref } from './trainingRoutes';
import './TrainingNavigation.css';

export default function TrainingNavigation({ current = 'courses', revision = 0 }) {
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError('');
    academyGet('/courses/workspace/meta', controller.signal).then(result => {
      if (controller.signal.aborted) return;
      setMeta(result?.response || null);
      setError(result?.error || (!result?.response ? 'Training tools could not be loaded.' : ''));
    }).catch(() => { if (!controller.signal.aborted) { setMeta(null); setError('Training tools could not be loaded.'); } });
    return () => controller.abort();
  }, [revision, retry]);
  const tabs = [['courses', 'Courses'], ...(meta?.allowed ? TRAINING_TABS : [])];
  if (meta?.owner || meta?.canInitialize) tabs.push(['access', 'Access']);
  const salesTools = userHasAnyRole('Sales', 'Sales Manager', 'Sales and Inventory Manager', 'Admin', 'Super Admin');
  return <div className="training-navigation">
    <div className="training-navigation-heading"><div><h2>Training</h2><p>Learn, practice and use your tools right here.</p></div>{salesTools && <Link className="training-conversation-link" to="/conversation-bank">Conversation Bank →</Link>}</div>
    <nav className="training-subtabs" aria-label="Training sections">{tabs.map(([id, label]) => <Link key={id} to={id === 'courses' ? TRAINING_HOME : workspaceHref(id)} aria-current={current === id ? 'page' : undefined}>{label}</Link>)}</nav>
    {error && <p className="training-navigation-error" role="alert">{error} <button type="button" onClick={() => setRetry(n => n + 1)}>Try again</button></p>}
  </div>;
}
